/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($categoryId: ID!, $contentDetailId: ID!) {
    VideoCategoryUpdate(
      categoryId: $categoryId
      contentDetailId: $contentDetailId
    ) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
